var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{attrs:{"id":"map","src":"static/getpoint/index.html","width":"915","height":"610"}})
}
var staticRenderFns = []

export { render, staticRenderFns }